import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shell padding20px" }
const _hoisted_2 = { class: "line-height30px" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_access_group_model = _resolveComponent("access-group-model")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_access_group_model, {
        roomId: _ctx.roomId,
        departmentId: _ctx.departmentId,
        role: _ctx.role,
        id: _ctx.id,
        selectItem: _ctx.initAccess,
        onWatchSelectValue: _ctx.multipleSelect
      }, {
        default: _withCtx(() => [
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextAccessGroup), 1)
        ]),
        _: 1
      }, 8, ["roomId", "departmentId", "role", "id", "selectItem", "onWatchSelectValue"]),
      _hoisted_3,
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}